import React from 'react';

import { Typography } from '@mui/material';

import { Flex } from '../ui/flex';

import { ErrorBoxProps } from './ErrorBox.types';

const ErrorBox = ({
  header = 'Oh no, something went wrong',
  description = 'Try refreshing the application'
}: ErrorBoxProps) => {
  return (
    <Flex
      align="center"
      justify="center"
      style={{
        background: 'white',
        width: 'contain',
        padding: '2em',
        maxWidth: '450px',
        gap: '.5em',
        borderRadius: '.5em',
        color: '#26282B'
      }}
    >
      <Typography variant="h5">{header}</Typography>
      <Typography variant="subtitle1">{description}</Typography>
    </Flex>
  );
};

export default ErrorBox;
